<template>
  <div>
    <div class="row mb-2" v-for="alert of alertList" :key="alert.key">
      <div class="col-4">
        <FormSelect :options="TaskAlertTypeLookup" v-model="alert.type" @input="itemUpdated(alert)" v-if="editing" />
        <span v-if="!editing">{{alert.type | formatLookupName(TaskAlertTypeLookup)}}</span>
      </div>
      <div class="col-6">
        <FormSelect :options="timeLookup" v-model="alert.timeBefore" @input="itemUpdated(alert)" v-if="editing" />
        <span v-if="!editing">{{alert.timeBefore | formatLookupName(timeLookup)}}</span>
      </div>
      <div class="col-2" v-if="editing">
        <ActionDropMenu :tableAction="true">
          <DropdownMenuItem @click="removeAlert(alert)" icon="fa-trash-alt">Remove Item</DropdownMenuItem>
        </ActionDropMenu>
      </div>
    </div>
    <p class="text-muted font-italic" v-if="!editing && alertList.length == 0">No alerts added</p>

    <ActionButton type="new" class="btn-xxs mt-1" @click="addAlert" v-if="editing"> Add Alert</ActionButton>
  </div>
</template>

<script>
import _ from 'lodash'

import { TaskAlertTypes, TaskAlertTypeLookup } from '@/store/types'

export default {
  name: 'TaskAlertList',
  model: {
    event: 'update'
  },
  props: {
    value: Array,
    editing: Boolean
  },
  data() {
    return {
      alertList: this.generateKeyedList(this.$props.value || [])
    }
  },
  watch: {
    value: function() {
      this.alertList = this.generateKeyedList(this.$props.value || [])
    }
  },
  computed: {
    timeLookup() {
      return [
        { value: 0, name: 'At time of task' },
        { value: 5*60, name: '5 minutes before' },
        { value: 10*60, name: '10 minutes before' },
        { value: 15*60, name: '15 minutes before' },
        { value: 30*60, name: '30 minutes before' },
        { value: 1*60*60, name: '1 hour before' },
        { value: 2*60*60, name: '2 hours before' },
        { value: 1*24*60*60, name: '1 day before' },
        { value: 2*24*60*60, name: '2 days before' },
        { value: 7*24*60*60, name: '1 week before' },
      ]
    },
  },
  created() {
    this.TaskAlertTypeLookup = TaskAlertTypeLookup
  },
  methods: {
    addAlert() {
      this.alertList.push({
        key: this.getUniqueListKey(),
        type: TaskAlertTypes.notification,
        timeBefore: (15 * 60)
      })
      this.$emit('update', this.alertList)
    },
    removeAlert(alert) {
      this.alertList.splice(this.alertList.findIndex(listAlert => listAlert.key == alert.key), 1)
      this.$emit('update', this.alertList)
    },
    itemUpdated(alert) {
      this.$emit('update', this.alertList)
    }
  }


}
</script>